import { useEffect, useCallback, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';

import TableOptions from '../tableOptions';
import ReactApiService from '../../services/reactApiService'
import AppConfig from '../../services/appConfig';

const useStyles = makeStyles((theme) => ({
	root: {},
	aboutTitle: {
		width: '600px',
		fontSize: '1.4em',
		fontWeight: '600'
	},
	aboutContent: {
		width: '500px',
		marginLeft: '50px',
		fontSize: '1em',
		textAlign: 'left',
		'& div': {
			width: '150%',
			marginBottom: '1.2em',
			marginTop: '1.2em',
    },	
	}
}));

export default function TabAbout(props) {
	
	const config = AppConfig();
	const classes = useStyles();
	let [error, setError] = useState(false);
  let [content, setContent] = useState(false);

	// keep function reference.
  const getContent = useCallback(() => {
		const dataService = new ReactApiService();
		dataService.get('getAboutInfo')
			.then( 
				(response) => {
					setContent((prev) => response);
				},
				// Note: it's important to handle errors here
				// instead of a catch() block so that we don't swallow
				// exceptions from actual bugs in components.
				(error) => {
					setError(error);
				}	
			)
  }, []) 	
	
	useEffect(() => {
		if ( ! content ) {
			getContent()
		}
	},[content,getContent]);

	if (error) {
		return <div>Error: {error.message}</div>	
	} else {
		if (content) {
			return (
				<div>
					<div className={classes.aboutTitle} dangerouslySetInnerHTML={{__html: content.title}}></div>
					<div className={classes.aboutContent} dangerouslySetInnerHTML={{__html: content.content}}></div>
					<div className={classes.aboutContent} dangerouslySetInnerHTML={{__html: content.extra}}></div>
					<div>
						<TableOptions config={config} endpoint={'themeOptions'} visibleItemsPerPage={false} />
					</div>				
				</div>
			)
		} else {
			return (
				<div>
					<Stack spacing={1}>
						<Skeleton variant="text" width={800} height={70} />
						<Skeleton variant="rectangular" width={800} height={200} />
						<Skeleton variant="rectangular" width={800} height={300} />
					</Stack>
				</div>
			)		
		}
	}
}
